<div class="page page--vcenter u-text-center">
  <div><img src="../../assets/images/CaptoMD-logo.svg" alt="CaptoMD"></div>
  <h1 class="u-margin-top">{{ 'app.error.pageNotFound' | translate }}</h1>
</div>
